"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreAttributesStepToJSON = exports.PreAttributesStepFromJSONTyped = exports.PreAttributesStepFromJSON = void 0;
const _1 = require("./");
function PreAttributesStepFromJSON(json) {
    return PreAttributesStepFromJSONTyped(json, false);
}
exports.PreAttributesStepFromJSON = PreAttributesStepFromJSON;
function PreAttributesStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'previousNames': (json['previousNames'].map(_1.NameObjectFromJSON)),
        'aliases': (json['aliases'].map(_1.NameObjectFromJSON)),
        'eyeColor': json['eyeColor'],
        'hairColor': json['hairColor'],
        'heightFeet': json['heightFeet'],
        'heightInches': json['heightInches'],
        'weightPounds': json['weightPounds'],
    };
}
exports.PreAttributesStepFromJSONTyped = PreAttributesStepFromJSONTyped;
function PreAttributesStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'previousNames': (value.previousNames.map(_1.NameObjectToJSON)),
        'aliases': (value.aliases.map(_1.NameObjectToJSON)),
        'eyeColor': value.eyeColor,
        'hairColor': value.hairColor,
        'heightFeet': value.heightFeet,
        'heightInches': value.heightInches,
        'weightPounds': value.weightPounds,
    };
}
exports.PreAttributesStepToJSON = PreAttributesStepToJSON;
//# sourceMappingURL=PreAttributesStep.js.map